export const userFields = {
  fullName: {
    min: 3,
    max: 100,
  },
  email: {
    max: 320,
  },
  displayName: {
    min: 2,
    max: 100,
  },
  bio: {
    max: 500,
  },
  userPhoto: {
    maxSizeMB: 2,
    supportedFormats: ['image/jpg', 'image/jpeg', 'image/png'],
  },
};

export const trackFields = {
  trackName: {
    max: 30,
  },
};

export const socialLinkFields = {
  link: {
    max: 2000,
  },
};
